import React from 'react';
import Layout from '../components/Layout';

const Terms: React.FC = () => {
  return (
    <Layout title="Terms and Conditions" subtitle="Effective Date: 28 August 2024">
      <div className="max-w-4xl mx-auto space-y-8">
        {/* Introduction */}
        <div className="bg-dark-800/50 backdrop-blur-lg border border-white/10 rounded-2xl p-8">
          <p className="text-white/90 leading-relaxed">
            Welcome to Incupie Technologies Private Limited ("Incupie"). These Terms of Use
            govern your access to and use of our digital compression services, website, and
            related technologies (collectively, the "Services"). By using our Services, you
            agree to these Terms. If you do not agree, please refrain from using the Services.
          </p>
        </div>

        {/* Terms Sections */}
        <div className="space-y-6">
          <div className="bg-dark-800/50 backdrop-blur-lg border border-white/10 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p className="text-white/90">
              By accessing or using the Services provided by Incupie, you agree to comply
              with these Terms of Use, our Privacy Policy, and any additional guidelines,
              policies, or terms applicable to specific services offered by Incupie.
            </p>
          </div>

          <div className="bg-dark-800/50 backdrop-blur-lg border border-white/10 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">2. Services Overview</h2>
            <p className="text-white/90">
              Incupie provides AI-powered services for image, video, voice, and text generation.
              Our platform allows users to run cutting-edge AI models locally, including DALL-E,
              Stable Diffusion, GPT Models, and Voice AI technologies.
            </p>
          </div>

          <div className="bg-dark-800/50 backdrop-blur-lg border border-white/10 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">3. User Responsibilities</h2>
            <p className="text-white/90 mb-4">By using our Services, you agree to:</p>
            <ul className="list-disc list-inside text-white/80 space-y-2 ml-4">
              <li>Use the Services in compliance with all applicable laws and regulations</li>
              <li>Not use the Services for illegal, harmful, or malicious purposes</li>
              <li>Respect intellectual property rights and content policies</li>
              <li>Maintain the security of your account credentials</li>
            </ul>
          </div>

          <div className="bg-dark-800/50 backdrop-blur-lg border border-white/10 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">4. Intellectual Property</h2>
            <p className="text-white/90">
              All content, features, and functionality of our Services are owned by Incupie
              and are protected by copyright, trademark, and other intellectual property laws.
              You may not copy, modify, distribute, or reverse engineer any part of our Services
              without explicit written permission.
            </p>
          </div>

          <div className="bg-dark-800/50 backdrop-blur-lg border border-white/10 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">5. Limitation of Liability</h2>
            <p className="text-white/90">
              Incupie shall not be liable for any indirect, incidental, special, consequential,
              or punitive damages resulting from your use of the Services. Our total liability
              shall not exceed the amount paid by you for the Services in the twelve months
              preceding the claim.
            </p>
          </div>

          <div className="bg-dark-800/50 backdrop-blur-lg border border-white/10 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">6. Termination</h2>
            <p className="text-white/90">
              We reserve the right to terminate or suspend your access to the Services at any time,
              with or without cause, and with or without notice. Upon termination, your right to
              use the Services will cease immediately.
            </p>
          </div>

          <div className="bg-dark-800/50 backdrop-blur-lg border border-white/10 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">7. Changes to Terms</h2>
            <p className="text-white/90">
              We may update these Terms from time to time. Any changes will be posted on our
              website with the updated effective date. Your continued use of the Services after
              any changes indicates your acceptance of the new Terms.
            </p>
          </div>
        </div>

        {/* Contact Information */}
        <div className="bg-gradient-to-r from-primary-500/10 to-primary-600/10 border border-primary-500/20 rounded-2xl p-8">
          <h2 className="text-2xl font-bold text-white mb-4">Contact Us</h2>
          <p className="text-white/90 mb-4">
            If you have any questions about these Terms and Conditions, please contact us:
          </p>
          <div className="space-y-2 text-white/90">
            <p><strong className="text-white">Email:</strong>{' '}
              <a href="mailto:support@incupie.com" className="text-primary-400 hover:text-primary-300 transition-colors">
                support@incupie.com
              </a>
            </p>
            <p><strong className="text-white">Phone:</strong> +91-9915080818</p>
            <p><strong className="text-white">Address:</strong><br />
               Incupie Technologies Private Limited<br />
               No. 19, 4th C Cross Koramangala Industrial,<br />
               5th Block, Area, Bengaluru, Karnataka 560095, India</p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Terms;
